import InsuranceLoadingShimmer from './insurance'

export default InsuranceLoadingShimmer
